import { render, staticRenderFns } from "./manage-content.vue?vue&type=template&id=c53f1e90&scoped=true&"
import script from "./manage-content.vue?vue&type=script&lang=js&"
export * from "./manage-content.vue?vue&type=script&lang=js&"
import style0 from "./manage-content.vue?vue&type=style&index=0&id=c53f1e90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53f1e90",
  null
  
)

export default component.exports